// import { IoMail } from "react-icons/io5";
// import {
//   FaDiscord,
//   FaFacebookF,
//   FaLinkedinIn,
//   FaYoutube,
// } from "react-icons/fa";
// import footerBg from "../../Assets/Footer.png";
// import footerLogo from "../../Assets/FooterLogo.png";
// import { PiPhoneCallFill } from "react-icons/pi";
// import { useNavigate } from "react-router-dom";

// const UserFooter = () => {  
//   const navigate = useNavigate();

//   const services = [
//     { name: "AI Development", path: "ai-development" },
//     { name: "Web Development", path: "web-development" },
//     { name: "Mobile App Development", path: "mobile-app-development" },
//     { name: "Cloud Solutions", path: "cloud-solutions" },
//   ];

//   const handleScroll = (item) => {
//     if (item.name === "Admin login"){
//       navigate("/login");
//     }
//     if (typeof item === "object" && item.path) {
//       navigate(`/services/${item.path}`);
//       window.scrollTo(0, 0);
//     } else {
//       const element = document.getElementById(
//         item.toLowerCase().replace(/\s+/g, "-"),
//       );
//       if (element) {
//         element.scrollIntoView({ behavior: "smooth" });
//       }
//     }
//   };

//   return (
//     <footer className="relative bg-[#080101]/80 text-white pt-10 overflow-hidden">
//       {/* Background Pattern Overlay */}
//       <div
//         className="absolute inset-0  h-full w-full pointer-events-none opacity-50 bg-bottom bg-no-repeat bg-cover"
//         style={{ backgroundImage: `url(${footerBg})` }}
//       />

//       <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-20 xl:px-40 relative z-10">
//         {/* Top Section: Logo and Contact */}
//         <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-8">
//           <img
//             src={footerLogo}
//             alt="Datoula"
//             className="h-12 md:h-20 w-auto object-contain cursor-pointer"
//             onClick={() => navigate("/")}
//           />

//           <div className="flex flex-col gap-4">
//             <div className="flex items-center gap-3">
//               <IoMail className="text-[#FF9437] text-xl" />
//               <span className="text-sm font-medium">info@datoula.com</span>
//             </div>
//             <div className="flex items-center gap-3">
//               <PiPhoneCallFill className="text-[#FF9437] text-xl" />
//               <span className="text-sm font-medium">+971 50 830 6848</span>
//             </div>
//           </div>
//         </div>

//         {/* Gradient Divider */}
//         <div className="w-full h-px bg-gradient-to-r from-[#D033AE] to-[#425CFE] mb-10 opacity-50" />

//         {/* Middle Section: Big Text and Links */}
//         <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-12 lg:gap-8 mb-10">
//           {/* Main Slogan Column */}
//           <div className="lg:col-span-2">
//             <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight">
//               Shaping the Ai
//               <br />
//               <span className="bg-gradient-to-r from-[#D033AE] to-[#425CFE] bg-clip-text text-transparent">
//                 Future
//               </span>
//             </h2>
//           </div>

//           {/* Links Column */}
//           <div>
//             <h3 className="text-xl font-bold mb-6 relative inline-block">
//               Links
//               <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#D033AE] to-[#425CFE]" />
//             </h3>
//             <ul className="space-y-2">
//               {[
//                 "Admin login",
//                 ...services,
//               ].map((link) => (
//                 <li key={typeof link === "string" ? link : link.name}>
//                   <button
//                     onClick={() => handleScroll(link)}
//                     className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left"
//                   >
//                     {typeof link === "string" ? link : link.name}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Explore Column */}
//           <div>
//             <h3 className="text-xl font-bold mb-6 relative inline-block">
//               Explore
//               <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#D033AE] to-[#425CFE]" />
//             </h3>
//             <ul className="space-y-4">
//               {[
//                 "Meet the Team",
//                 "Support",
//                 "Privacy Policy",
//                 "Terms of Use",
//               ].map((link) => (
//                 <li key={link}>
//                   <button
//                     onClick={() => handleScroll(link)}
//                     className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left"
//                   >
//                     {link}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div>
//             <h3 className="text-xl font-bold mb-6 relative inline-block">
//               Contact
//               <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#D033AE] to-[#425CFE]" />
//             </h3>
//               <ul className="space-y-4">
//                 <li className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left">Meydan Grandstand, 6th Floor, Meydan Road, Nad Al Sheba,</li>
//                 <li className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left "> Dubai, U.A.E</li>
//                 <li className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left ">info@datoula.com</li>
//                 <li className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left ">+971 50 830 6848</li>
//               </ul>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Bar: Copyright and Socials */}
//       <div className="px-6 md:px-16 flex flex-col sm:flex-row justify-between items-center py-6 border-t border-white/10 gap-6 bg-black/20">
//         <p className="text-sm text-gray-400 font-medium text-center sm:text-left">
//           DATOULA© 2026. All Rights Reserved.
//         </p>

//         <div className="flex items-center gap-4">
//           {[FaDiscord, FaFacebookF, FaLinkedinIn, FaYoutube].map(
//             (Icon, idx) => (
//               <a
//                 key={idx}
//                 href="#"
//                 className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 transition-all border border-white/5"
//               >
//                 <Icon className="text-sm text-white" />
//               </a>
//             ),
//           )}
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default UserFooter;


import { IoMail } from "react-icons/io5";
import {
  FaDiscord,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import footerBg from "../../Assets/Footer.png";
import footerLogo from "../../Assets/FooterLogo.png";
import { PiPhoneCallFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

const UserFooter = () => {
  const navigate = useNavigate();

  const services = [
    { name: "AI Development", slug: "ai-development" },
    { name: "Web Development", slug: "web-development" },
    { name: "Mobile App Development", slug: "mobile-app-development" },
    { name: "Cloud Solutions", slug: "cloud-solutions" },
  ];

  const quickLinks = [
    { name: "Admin Login", path: "/login" },
  ];

  const exploreLinks = [
    { name: "About", path: "/about" },
    { name: "FAQ", path: "/faq" },
    { name: "Contact", path: "/contact" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Terms of Use", path: "/terms-of-use" },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="relative bg-[#080101]/80 text-white pt-10 overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 h-full w-full pointer-events-none opacity-50 bg-bottom bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${footerBg})` }}
      />

      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-20 xl:px-40 relative z-10">
        
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-8">
          <img
            src={footerLogo}
            alt="Datoula"
            className="h-12 md:h-20 w-auto object-contain cursor-pointer"
            onClick={() => handleNavigate("/")}
          />

          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <IoMail className="text-[#FF9437] text-xl" />
              <span className="text-sm font-medium">info@datoula.com</span>
            </div>

            <div className="flex items-center gap-3">
              <PiPhoneCallFill className="text-[#FF9437] text-xl" />
              <span className="text-sm font-medium">+971 50 830 6848</span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-gradient-to-r from-[#D033AE] to-[#425CFE] mb-10 opacity-50" />

        {/* Middle Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-12 lg:gap-8 mb-10">
          
          {/* Slogan */}
          <div className="lg:col-span-2">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight">
              Shaping the AI
              <br />
              <span className="bg-gradient-to-r from-[#D033AE] to-[#425CFE] bg-clip-text text-transparent">
                Future
              </span>
            </h2>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6 relative inline-block">
              Services
              <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#D033AE] to-[#425CFE]" />
            </h3>

            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.slug}>
                  <button
                    onClick={() =>
                      handleNavigate(`/services/${service.slug}`)
                    }
                    className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left"
                  >
                    {service.name}
                  </button>
                </li>
              ))}

              {quickLinks.map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => handleNavigate(link.path)}
                    className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-xl font-bold mb-6 relative inline-block">
              Explore
              <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#D033AE] to-[#425CFE]" />
            </h3>

            <ul className="space-y-3">
              {exploreLinks.map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => handleNavigate(link.path)}
                    className="text-[#8C9ED3] hover:text-white transition-colors text-sm font-medium text-left"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-6 relative inline-block">
              Contact
              <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-[#D033AE] to-[#425CFE]" />
            </h3>

            <ul className="space-y-4">
              <li className="text-[#8C9ED3] text-sm font-medium">
                Meydan Grandstand, 6th Floor,
              </li>
              <li className="text-[#8C9ED3] text-sm font-medium">
                Meydan Road, Nad Al Sheba,
              </li>
              <li className="text-[#8C9ED3] text-sm font-medium">
                Dubai, U.A.E
              </li>
              <li className="text-[#8C9ED3] text-sm font-medium">
                info@datoula.com
              </li>
              <li className="text-[#8C9ED3] text-sm font-medium">
                +971 50 830 6848
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="px-6 md:px-16 flex flex-col sm:flex-row justify-between items-center py-6 border-t border-white/10 gap-6 bg-black/20">
        <p className="text-sm text-gray-400 font-medium text-center sm:text-left">
          DATOULA © 2026. All Rights Reserved.
        </p>

        <div className="flex items-center gap-4">
          {[
            { icon: FaDiscord, url: "https://discord.com" },
            { icon: FaFacebookF, url: "https://facebook.com" },
            { icon: FaLinkedinIn, url: "https://linkedin.com" },
            { icon: FaYoutube, url: "https://youtube.com" },
          ].map((social, idx) => {
            const Icon = social.icon;

            return (
              <a
                key={idx}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 transition-all border border-white/5"
              >
                <Icon className="text-sm text-white" />
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
};

export default UserFooter;